<template>
  <router-link
    :to="{ name: 'RecipeDetail',
            params: {
              id: recipe.id
            }
          }" class="recipe-item">
    <mu-card>
      <div :class="'imgLoadContainer' + '_' + uid" style="text-align: center;position:relative">
        <img v-show="!imageLoaded"
             src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZAAAAD6CAQAAAAlrtnPAAAB2UlEQVR42u3TMQEAAAgDINc/9Lw9bAAdSDvAI4KAICAICAKCgCAgCAgCgoAggCAgCAgCgoAgIAgIAoKAICAIIAgIAoKAICAICAKCgCAgCCAICAKCgCAgCAgCgoAgIAgIAggCgoAgIAgIAoKAICAICAIIAoKAICAICAKCgCAgCAgCggCCgCAgCAgCgoAgIAgIAoIAgoAgIAgIAoKAICAICAKCgCCAICAICAKCgCAgCAgCgoAgIIggIAgIAoKAICAICAKCgCAgCCAICAKCgCAgCAgCgoAgIAgIAggCgoAgIAgIAoKAICAICAIIAoKAICAICAKCgCAgCAgCggCCgCAgCAgCgoAgIAgIAoIAgoAgIAgIAoKAICAICAKCgCCAICAICAKCgCAgCAgCgoAggCAgCAgCgoAgIAgIAoKAICAIIAgIAoKAICAICAKCgCAgCAgiCAgCgoAgIAgIAoKAICAICAIIAoKAICAICAKCgCAgCAgCggCCgCAgCAgCgoAgIAgIAoIAgoAgIAgIAoKAICAICAKCgCCAICAICAKCgCAgCAgCgoAggCAgCAgCgoAgIAgIAoKAICAIIAgIAoKAICAICAKCgCAgCCAICAKCgCAgCAgCgoAgIAgIAlwLZBnzFqLt6FUAAAAASUVORK5CYII=">
        <img :alt="recipe.title  + ' image'" v-show="recipe.photoSmallUri != null && imageLoaded"
             :src="recipe.photoSmallUri" width="100%">
        <img :alt="'Empty image'" v-show="recipe.photoSmallUri == null && imageLoaded"
             src="static/emptyImgPlaceholder.png" width="100%">
        <img
          src="static/rollingSpinner.gif"
          v-if="!imageLoaded"
          style="margin: 0 auto; margin: 0px auto; position: absolute;height: 32px;width: 32px;vertical-align: middle;align-items: center;display: flex;text-align: center;align-content: center;top: 50% ;left: calc(50% - 16px);"/>

        <div style="position:absolute; top: 8px;right: 8px" v-if="recipe.video_url !== null">
          <mu-chip>
            <mu-icon style="padding-top:4px;padding-bottom: 4px;" value="ondemand_video"></mu-icon>
          </mu-chip>
        </div>
      </div>
      <mu-card-text style="margin-top: -6px">
        <div style="margin-bottom: 2px;" class="overflowText recipeCardTitle">{{ recipe.title }}</div>
        <div v-if="recipe.categories.length > 0" style="margin-bottom: 8px" class="overflowText">
          <span v-for="tag, i in recipe.categories"  :title="tag" :key="'recipe-' +  i">{{ tag }}<span
            v-if="recipe.categories.length-1 !== i">, </span></span>
        </div>
        <div v-if="recipe.categories.length === 0" style="margin-bottom: 8px">No categories</div>
        <mu-chip class="carbTag" color="#4479C9" background-color="white">
          {{ oneCarbPortion.toFixed(0) + 'g' }}
        </mu-chip>
        <mu-chip class="timeTag" background-color="white">{{ formatTime(recipe.totalTime * 60000) }}</mu-chip>
        <recipe-rating :read-only="true" style="margin-top: 8px;" :rating="recipe.rating.ratingScore"
                       :count="recipe.rating.ratingCount" :recipe="recipe"></recipe-rating>
      </mu-card-text>
    </mu-card>
  </router-link>
</template>
<script>
import $ from 'jquery'
import imagesLoaded from 'imagesloaded'
import moment from 'moment'
import EventBus from '../../../helpers/EventBus'

import RecipeRating from "./RecipeRating";
import MuChip from "muse-ui/src/chip/chip";

export default {
  components: {
    MuChip,
    RecipeRating
  },
  name: "recipe-card",
  props: ['recipe'],
  data() {
    return {
      uid: this._uid,
      imageLoaded: false,
    }
  },
  watch: {
    'recipe': 'runImageLoader'
  },
  mounted() {
    this.runImageLoader();
  },
  computed: {
    oneCarbPortion() {
      let self = this;
      let
        carbValue = self.recipe.nutrition.carbohydrate.val,
        servings = self.recipe.servings;

      return carbValue * (1 / servings);
    }
  },
  methods: {


    goTo(id) {
      let self = this;
      if (self.$store.state.status.payment.paid) {
        self.$router.push({
          name: 'RecipeDetail',
          params: {
            id: id
          }
        })
      } else {
        EventBus.$emit('App::triggerPaywall', true);
      }
    },
    isInt(n) {
      return n % 1 === 0;
    },
    formatTime(ms) {
      let self = this;
      moment.relativeTimeThreshold('ss', 1000);
      moment.relativeTimeThreshold('s', 59);
      moment.relativeTimeThreshold('m', 59);
      moment.relativeTimeThreshold('h', 23);

      let totalMinutes = moment.duration(ms, 'milliseconds').asMinutes();
      let hours = parseInt(totalMinutes / 60);
      let minutes = parseInt(totalMinutes - (hours * 60));

      if (self.isInt(hours) && parseInt(minutes) === 0) {
        return hours + 'h';
      }
      if (hours < 1 && minutes > 0) {
        return (minutes) + ' min'
      }
      if (hours >= 1 && minutes >= 1) {
        return hours + 'h ' + (minutes) + ' min'
      }
    },
    runImageLoader() {
      let self = this;
      imagesLoaded($('.imgloadContainer_' + self.uid), function () {

        self.imageLoaded = true;

      });
      /**
       setTimeout(function () {
          self.imageLoaded = true;
        }, 1000);
       **/
    }
  }
}
</script>
<style>

.carbTag {
  color: #0179d5;
  border: 1px solid #0179d5;
  box-shadow: none;
}

.timeTag {
  color: rgba(51, 51, 51, 0.87);
  border: 1px solid rgba(51, 51, 51, 0.87);
  box-shadow: none;
}

.recipe-item {
  cursor: pointer;
}

a.recipe-item {
  display: block;
}

.recipeCardTitle {
  font-size: 18px;
}

.overflowText {
  width: 95%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// RecipeCard.vue?59cdc834